/* src/app/system-view/main-dashboard/chart-card/chart-card.component.scss */
:host {
  display: block;
  height: 100%;
}
.cc-shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-height: 0;
  border-radius: var(--tem-radius);
  border: 1px solid var(--tem-border);
  box-shadow: var(--tem-shadow);
  background: var(--tem-surface);
  overflow: hidden;
  transition: border-color 0.2s ease;
}
.cc-shell:hover {
  border-color: var(--tem-deep);
}
.cc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--tem-space-1) var(--tem-space-1) var(--tem-space-1) var(--tem-space-3);
  border-bottom: 1px solid var(--tem-border);
  flex-shrink: 0;
  background: var(--tem-surface-2);
  max-height: 40px;
}
.cc-title-group {
  display: flex;
  align-items: center;
  gap: var(--tem-space-2);
  min-width: 0;
}
.cc-title-icon {
  font-size: var(--tem-fs-lg);
  color: var(--tem-deep);
  flex-shrink: 0;
}
.cc-title {
  font-size: var(--tem-fs-md);
  font-weight: 600;
  color: var(--tem-ink);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
.cc-menu-icon {
  margin-right: var(--tem-space-2);
}
.cc-chart-wrapper {
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
  position: relative;
  background: var(--tem-surface);
}
.cc-expand-btn {
  position: absolute;
  right: 5px;
  top: 2px;
  z-index: 10;
  opacity: 0.55;
  transition: opacity 0.2s ease;
}
.cc-expand-btn:hover {
  opacity: 1;
}
.cc-spin {
  height: 100%;
}
.cc-spin ::ng-deep .ant-spin-container {
  height: 100%;
}
.cc-chart-body {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.cc-footer {
  display: flex;
  align-items: center;
  padding: var(--tem-space-1) var(--tem-space-3);
  border-top: 1px solid var(--tem-border);
  flex-shrink: 0;
}
.cc-last-update {
  display: inline-flex;
  align-items: center;
  gap: var(--tem-space-1);
  font-size: var(--tem-fs-sm);
  font-weight: 500;
  color: var(--tem-warn);
  background: color-mix(in srgb, var(--tem-warn) 10%, transparent);
  border-radius: 20px;
  padding: 2px var(--tem-space-2);
}
.cc-last-update-icon {
  font-size: var(--tem-fs-sm);
}
/*# sourceMappingURL=chart-card.component.css.map */
